module.exports = __webpack_public_path__ + "img/17.764fd9fa.svg";